import request from "@/utils/request";

export function getBase64(url) {
  return request({
    url: url,
    method: "get",
    
  });
}

export function getPaymentInfo(params) {
  return request({
    url: "/api/nonbid/index/detail",
    method: "get",
    params
  });
}

export function offlinePost(data) {
  return request({
    url: '/api/nonbid/index/paymentVoucher',
    method: 'post',
    ContentType: 'multipart/form-data',
    data,
  });
}